import { render, staticRenderFns } from "./appointmentDialog.vue?vue&type=template&id=0fdc35d0&scoped=true"
import script from "./appointmentDialog.vue?vue&type=script&lang=js"
export * from "./appointmentDialog.vue?vue&type=script&lang=js"
import style0 from "./appointmentDialog.vue?vue&type=style&index=0&id=0fdc35d0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fdc35d0",
  null
  
)

export default component.exports